import { detectDeviceEnvironmentConstants, dispatcher, IEvent, ingenuity, IObject } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, SymbolBaseMurka, View } from "@quest/murka-games-behavior-panther/dist";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class BaseGameViewGame extends View {
  /**
   * Method overrided to add game component.
   */
  protected initializeComponents(): void {
    super.initializeComponents();
  }

  // Method overrided
  public setReelView(reelView: any, pos: any, parentId: any) {
    this.reelView = reelView;
    this.addChildAt(this.getSpineById("Basegame_Desktop"), 0);
    this.addChildAt(this.getImageById("reelBG"), 1);
    this.addChildAt(reelView, 3);
    const reelsContainer = this.getContainerByID("reelsContainer");
    this.addChildAt(reelsContainer, 4);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.reelView.x = this.reelView.json.portraitX;
      this.reelView.y = this.reelView.json.portraitY;
    }
  }

  // Override to play landing animation
  public landingAnimation(data: any) {
    const reelgrid = data[0];
    const reelview = data[1];
    const reelId = data[2];
    for (let i = 5; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const symbol: SymbolBaseMurka = reelview.getSymbolByPos(reelId, i);
        this.playSpecialSymbolSound(symbol.symNum);
        const staticSym = symbol.getStatic();
        const animSym: any = symbol.getAnimation();
        if (animSym) {
          const staticSymParent = staticSym.parent;
          if (staticSymParent) {
            staticSym.visible = false;
            animSym.visible = true;
            staticSymParent.addChild(animSym);
            const staticAnim = animSym.json.animations ? animSym.json.animations.static : "static";
            const landingAnim = animSym.json.animations ? animSym.json.animations.landing : "landing";
            animSym.playAnim(staticAnim, false, 0);
            animSym.onComplete.addOnce(() => {
              animSym.playAnim(landingAnim, false);
            }, this);
          }
        }
      }
    }
  }

  protected resizeOrientation(e?: IObject): void {
    super.resizeOrientation(e);
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
      this.x = this.x + (gameConstants.ADD_IN_X * this.scale.x);
    }
    if(!ingenuity.deviceEnv.isDesktop){
      dispatcher.fireEvent(eventDispatchers.ALIGN_PROGRESS_BAR);
    }
  }

   /**
   * Method to play landing sound.
   * @param symbolNumber 
   */
  private playSpecialSymbolSound(symbolNumber: number): void {
    const soundMap: { [key: number]: string } = {
      [gameConstants.SPECIAL_SYMBOL_NOTE_ID]: SoundConstantGame.LETTER_DROP_SOUND,
      [gameConstants.SPECIAL_SYMBOL_MAGNIFY_ID]: SoundConstantGame.MAGNIFY_DROP_SOUND,
      [gameConstants.SPECIAL_SYMBOL_KEY_ID]: SoundConstantGame.KEY_DROP_SOUND,
      [gameConstants.SPECIAL_SYMBOL_SPOTLIGHT_ID]: SoundConstantGame.LANTERN_ICON_DROP
    };

    const soundObj: IObject = { id: soundMap[symbolNumber], vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD };

    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
  }


  /**
   * to show all symbols alpha which are present on grid
   */
  protected showAlpha(): void {
    if (this.reelView) {
      for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
        for (let symbol = 0; symbol < 10; symbol++) {
          this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0xffffff;
          const anim = this.reelView.getSymbolByPos(reel, symbol).getAnimation() as any;
           if (anim.name === "Note" || anim.name === "MagnifyingGlass" || anim.name === "Key" || anim.name === "Spotlight") {
            if (anim !== undefined) {
              anim.tint = 0xffffff;
            }
          }
        }
      }
    }
  }

  /**
   * to hide all symbols alpha which are present on grid
   */
  protected hideAlpha(): void {
    if (this.reelView) {
      for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
        for (let symbol = 0; symbol < 10; symbol++) {
          this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0xffffff;
          const anim = this.reelView.getSymbolByPos(reel, symbol).getAnimation() as any;
           if (anim.name === "Note" || anim.name === "MagnifyingGlass" || anim.name === "Key" || anim.name === "Spotlight") {
            if (anim !== undefined) {
              anim.tint = 0xffffff;
            }
          }
        }
      }
    }
  }

  /**
   * to hide symbols alpha which are part of winning line
   */
  protected hideAlphaOnWinSymbol(evt: IEvent): void {
    if (this.reelView) {
      this.showAlpha();
      if (evt === null || evt === void 0 ? void 0 : evt.data) {
        for (const winSymData of evt.data) {
          this.reelView.getSymbolByPos(winSymData[0], winSymData[1]).getStatic().tint = 0xffffff;
          const anim = this.reelView.getSymbolByPos(winSymData[0], winSymData[1]).getAnimation() as any;
           if (anim.name === "Note" || anim.name === "MagnifyingGlass" || anim.name === "Key" || anim.name === "Spotlight") {
            if (anim !== undefined) {
              anim.tint = 0xffffff;
            }
          }
        }
      }
    }
  }

   /**
   * overide to add win collection view on top
   */
  protected addButtonPanelOnTop(): void {
    super.addButtonPanelOnTop();
    dispatcher.fireEvent(eventDispatchers.ADD_LIGHTNING_VIEW_ON_TOP); //game event
  }
}
